export default {
    workOrder_contactTab_name: "Nombre",
    workOrder_contactTab_email: "Correo",
    workOrder_contactTab_notifyByEmail: "Notificar por Correo",
    workOrder_contactTab_phone: "Teléfono",
    workOrder_contactTab_notifyByPhone: "Notificar por Teléfono",
    workOrder_contactTab_createdOn: "Fecha de Creación",
}